"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _AttachmentLink = _interopRequireDefault(require("./AttachmentLink"));
var _RfqLinePartDetail = _interopRequireDefault(require("./RfqLinePartDetail"));
var _RfqLineQuantity = _interopRequireDefault(require("./RfqLineQuantity"));
var _RfqLineRequirement = _interopRequireDefault(require("./RfqLineRequirement"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The RfqLine model module.
 * @module model/RfqLine
 * @version 0.0.1
 */
var RfqLine = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>RfqLine</code>.
   * @alias module:model/RfqLine
   */
  function RfqLine() {
    _classCallCheck(this, RfqLine);
    RfqLine.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(RfqLine, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>RfqLine</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/RfqLine} obj Optional instance to populate.
     * @return {module:model/RfqLine} The populated <code>RfqLine</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new RfqLine();
        if (data.hasOwnProperty('id')) {
          obj['id'] = _ApiClient["default"].convertToType(data['id'], 'Number');
        }
        if (data.hasOwnProperty('nsn')) {
          obj['nsn'] = _ApiClient["default"].convertToType(data['nsn'], 'String');
        }
        if (data.hasOwnProperty('description')) {
          obj['description'] = _ApiClient["default"].convertToType(data['description'], 'String');
        }
        if (data.hasOwnProperty('part_numbers')) {
          obj['part_numbers'] = _ApiClient["default"].convertToType(data['part_numbers'], ['String']);
        }
        if (data.hasOwnProperty('custom_fields')) {
          obj['custom_fields'] = _ApiClient["default"].convertToType(data['custom_fields'], ['String']);
        }
        if (data.hasOwnProperty('clauses')) {
          obj['clauses'] = _ApiClient["default"].convertToType(data['clauses'], ['String']);
        }
        if (data.hasOwnProperty('part_details')) {
          obj['part_details'] = _ApiClient["default"].convertToType(data['part_details'], [_RfqLinePartDetail["default"]]);
        }
        if (data.hasOwnProperty('quantities')) {
          obj['quantities'] = _ApiClient["default"].convertToType(data['quantities'], [_RfqLineQuantity["default"]]);
        }
        if (data.hasOwnProperty('attachments')) {
          obj['attachments'] = _ApiClient["default"].convertToType(data['attachments'], [_AttachmentLink["default"]]);
        }
        if (data.hasOwnProperty('requirements')) {
          obj['requirements'] = _ApiClient["default"].convertToType(data['requirements'], [_RfqLineRequirement["default"]]);
        }
      }
      return obj;
    }
  }]);
}();
/**
 * @member {Number} id
 */
RfqLine.prototype['id'] = undefined;

/**
 * @member {String} nsn
 */
RfqLine.prototype['nsn'] = undefined;

/**
 * @member {String} description
 */
RfqLine.prototype['description'] = undefined;

/**
 * @member {Array.<String>} part_numbers
 */
RfqLine.prototype['part_numbers'] = undefined;

/**
 * @member {Array.<String>} custom_fields
 */
RfqLine.prototype['custom_fields'] = undefined;

/**
 * @member {Array.<String>} clauses
 */
RfqLine.prototype['clauses'] = undefined;

/**
 * @member {Array.<module:model/RfqLinePartDetail>} part_details
 */
RfqLine.prototype['part_details'] = undefined;

/**
 * @member {Array.<module:model/RfqLineQuantity>} quantities
 */
RfqLine.prototype['quantities'] = undefined;

/**
 * @member {Array.<module:model/AttachmentLink>} attachments
 */
RfqLine.prototype['attachments'] = undefined;

/**
 * @member {Array.<module:model/RfqLineRequirement>} requirements
 */
RfqLine.prototype['requirements'] = undefined;
var _default = exports["default"] = RfqLine;